"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom.iterable");

var _objectSpread2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/objectSpread2"));

var _index = _interopRequireDefault(require("@/components/Pagination/index"));

var _waves = _interopRequireDefault(require("@/directive/waves"));

var _lang = _interopRequireDefault(require("@/lang"));

var _httpUtils = _interopRequireDefault(require("@/utils/http-utils"));

var _PermissionPage = _interopRequireDefault(require("@/components/Page/PermissionPage"));

var _PermissionSimplePage = _interopRequireDefault(require("@/components/Page/PermissionSimplePage"));

var _vuex = require("vuex");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: "payChannelGroup:view",
  extends: _PermissionPage.default,
  components: {
    Pagination: _index.default,
    PermissionSimplePage: _PermissionSimplePage.default
  },
  directives: {
    waves: _waves.default
  },
  data: function data() {
    return {
      tableKey: 0,
      list: null,
      agentList: null,
      // channelList: null,
      channelGroupList: null,
      total: 0,
      listLoading: true,
      updateChannelFlag: false,
      addDialogVisible: false,
      addChannelDialogVisible: false,
      queryParameter: {
        pageNum: 1,
        pageSize: 10,
        id: null,
        state: null
      },
      addInformationParameter: {
        id: null,
        channelGroupName: null,
        state: null,
        remark: null
      },
      downloadLoading: false,
      multipleSelection: [],
      rules: {
        channelIds: [{
          required: true,
          message: _lang.default.t("channel.channelNameText") + " " + _lang.default.t("warningMessage.cannotBeEmpty"),
          trigger: "change"
        }],
        channelGroupName: [{
          required: true,
          message: _lang.default.t("channel.smsChannelGroupNameText") + " " + _lang.default.t("warningMessage.cannotBeEmpty"),
          trigger: "change"
        }],
        channelDetail: [{
          required: true,
          message: _lang.default.t("channel.channelNameText") + " " + _lang.default.t("warningMessage.cannotBeEmpty"),
          trigger: "change"
        }]
      }
    };
  },
  created: function created() {
    this.initList();
    this.getList();
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['statusOptions', 'costStatusOption'])),
  methods: {
    initList: function initList() {
      var _this2 = this;

      if (this.$store.getters.isAdmin) {
        //Initial channel list
        // httpUtils.post("smsChannel", "getAllSmsChannels", null, null).then((res) => {
        //   this.channelList = res.data;
        // });
        //Initial channel group list
        _httpUtils.default.post("payChannelGroup", "getAllPayChannelGroup", null, null).then(function (res) {
          _this2.channelGroupList = res.data;
        });
      }
    },
    getList: function getList() {
      var _this3 = this;

      //Set the loading button for table
      this.listLoading = true; //Get search parameters

      var params = this.getQueryParams();

      _httpUtils.default.post("payChannelGroup", "list", null, params).then(function (res) {
        _this3.list = res.data.rows;
        _this3.total = res.data.total;
      });

      setTimeout(function () {
        _this3.listLoading = false;
      }, 1 * 1000);
    },
    //Get search parameter for backend service
    getQueryParams: function getQueryParams() {
      return {
        pageNum: this.queryParameter.pageNum,
        pageSize: this.queryParameter.pageSize,
        id: this.queryParameter.id,
        state: this.queryParameter.state
      };
    },
    //Refresh table
    handleFilter: function handleFilter() {
      //Reset the page number of table
      this.queryParameter.pageNum = 1;
      this.getList();
    },
    //Get input parameters for backend service
    getAddInformationParameter: function getAddInformationParameter() {
      return {
        id: this.addInformationParameter.id,
        channelGroupName: this.addInformationParameter.channelGroupName,
        state: this.addInformationParameter.state,
        remark: this.addInformationParameter.remark
      };
    },
    //Validate input parameters
    handleAddGroup: function handleAddGroup() {
      var _this4 = this;

      var _this = this;

      this.$refs["addInformation"].validate(function (valid) {
        if (valid) {
          var params = _this.getAddInformationParameter();

          if (_this.updateChannelFlag) {
            _httpUtils.default.post("payChannelGroup", "update", null, params).then(function (res) {
              if (res.code === 200) {
                _this4.$message({
                  message: _lang.default.t("warningMessage.updateGroupSuccessMessage"),
                  type: "success"
                });
              }

              _this4.handleResetAdd();

              _this4.handleFilter();
            }).catch(function (e) {
              if (e.code == 500) {
                _this4.$message({
                  message: e.message,
                  type: "warning"
                });
              }
            });
          } else {
            _httpUtils.default.post("payChannelGroup", "add", null, params).then(function (res) {
              if (res.code === 200) {
                _this4.$message({
                  message: _lang.default.t("warningMessage.addGroupSuccessMessage"),
                  type: "success"
                });
              }

              if (res.code === 500) {
                _this4.$message({
                  message: e.message,
                  type: "error"
                });
              }

              _this4.handleResetAdd();

              _this4.handleFilter();
            }).catch(function (e) {
              _this4.$message({
                message: e.message,
                type: "error"
              });
            });
          }

          _this4.$refs["addInformation"].clearValidate();
        } else {
          return false;
        }
      });
    },
    deleteGroup: function deleteGroup(groupIds) {
      var _this5 = this;

      _httpUtils.default.post("payChannelGroup", "batchDelete", null, groupIds).then(function (res) {
        _this5.$message({
          message: _lang.default.t("warningMessage.deleteRecordSuccessMessage"),
          type: "success"
        });

        _this5.handleFilter();
      }).catch(function (err) {
        _this5.$message({
          message: err.message,
          type: "error"
        });
      });
    },
    handleDelete: function handleDelete(id) {
      var _this6 = this;

      this.$confirm(_lang.default.t("warningMessage.channelGroupDeleteGroupRemark"), _lang.default.t("warningMessage.deleteRecordMessage"), {
        confirmButtonText: _lang.default.t("common.confirm"),
        cancelButtonText: _lang.default.t("common.cancel"),
        type: "warning"
      }).then(function () {
        var ids = [];
        ids.push(id);

        _this6.$nextTick(function (_) {
          _this6.deleteGroup(ids);
        });
      }).catch(function (_) {});
    },
    handleBatchDelete: function handleBatchDelete() {
      var _this7 = this;

      var _this = this;

      if (!_this.multipleSelection.length) {
        this.$message({
          message: _lang.default.t("warningMessage.selectRecordToDeleteMessage"),
          type: "error"
        });
      } else {
        this.$confirm(_lang.default.t("warningMessage.channelGroupDeleteGroupRemark"), _lang.default.t("warningMessage.deleteRecordMessage"), {
          confirmButtonText: _lang.default.t("common.confirm"),
          cancelButtonText: _lang.default.t("common.cancel"),
          type: "warning"
        }).then(function () {
          var ids = [];

          for (var item in _this.multipleSelection) {
            ids.push(_this.multipleSelection[item].id);
          }

          _this7.$nextTick(function (_) {
            _this7.deleteGroup(ids);
          });
        }).catch(function (_) {});
      }
    },
    //Fill in parameters for updating channel group
    handleUpdateCheck: function handleUpdateCheck(row) {
      this.addInformationParameter.id = row.id;
      this.addInformationParameter.channelGroupName = row.channelGroupName;
      this.addInformationParameter.remark = row.remark;
      this.addInformationParameter.state = row.state;
      this.addDialogVisible = true;
      this.updateChannelFlag = true;
    },
    handleUpdateGroup: function handleUpdateGroup() {
      var _this8 = this;

      var _this = this;

      if (!_this.multipleSelection.length) {
        this.$message({
          message: _lang.default.t("warningMessage.selectGroupToUpdateMessage"),
          type: "error"
        });
      } else {
        this.$confirm(_lang.default.t("warningMessage.updateGroupConfirmMessage"), _lang.default.t("warningMessage.updateGroupMessage"), {
          confirmButtonText: _lang.default.t("common.confirm"),
          cancelButtonText: _lang.default.t("common.cancel"),
          type: "warning"
        }).then(function () {
          var ids = [];

          for (var item in _this8.multipleSelection) {
            ids.push(_this8.multipleSelection[item].id);
          }

          _this8.listLoading = true;

          _httpUtils.default.post("payChannelGroup", "batchUpdateGroup", null, ids).then(function (res) {
            _this8.$message({
              message: _lang.default.t("warningMessage.updateGroupDetailSuccessMessage"),
              type: "success"
            });

            _this8.handleFilter();
          }).catch(function (err) {
            _this8.$message({
              message: err.message,
              type: "error"
            });
          });

          setTimeout(function () {
            _this8.listLoading = false;
          }, 1 * 1000);
        }).catch(function (_) {});
      }
    },
    // handleAddChannel(row) {
    //   this.$router.push({
    //     name: "smsChannelGroupChannel:view",
    //     params: {channelGroupId: row.id, channelGroupName: row.channelGroupName},
    //   });
    // },
    // handleAddMember(row) {
    //   this.$router.push({
    //     name: "smsChannelGroupMember:view",
    //     params: {channelGroupId: row.id, channelGroupName: row.channelGroupName},
    //   });
    // },
    handleAddCost: function handleAddCost(row) {
      this.$router.push({
        name: "payChannelGroupCost:view",
        params: {
          channelGroupId: row.id,
          channelGroupName: row.channelGroupName
        }
      });
    },
    handleAddCostMember: function handleAddCostMember(row) {
      this.$router.push({
        name: "payChannelGroupCostMember:view",
        params: {
          channelGroupId: row.id,
          channelGroupName: row.channelGroupName
        }
      });
    },
    handleUpdateStatus: function handleUpdateStatus(status) {
      var _this9 = this;

      if (!this.multipleSelection.length) {
        this.$message({
          message: _lang.default.t("warningMessage.selectGroupToUpdateMessage"),
          type: "error"
        });
      } else {
        this.$confirm(_lang.default.t("warningMessage.updateGroupConfirmMessage"), _lang.default.t("warningMessage.updateGroupMessage"), {
          confirmButtonText: _lang.default.t("common.confirm"),
          cancelButtonText: _lang.default.t("common.cancel"),
          type: "warning"
        }).then(function () {
          if (status == "start" || status == "pause") {
            var ids = [];

            for (var item in _this9.multipleSelection) {
              ids.push(_this9.multipleSelection[item].id);
            }

            if (status == "start") {
              status = "1";
            } else {
              status = "0";
            }

            var params = {
              groupIds: ids,
              state: status
            };
            _this9.listLoading = true;

            _httpUtils.default.post("payChannelGroup", "updateGroupStatus", null, params).then(function (res) {
              _this9.$message({
                message: _lang.default.t("warningMessage.updateGroupStatusSuccessMessage"),
                type: "success"
              });

              _this9.handleFilter();
            }).catch(function (err) {
              _this9.$message({
                message: err.message,
                type: "error"
              });
            });

            setTimeout(function () {
              _this9.listLoading = false;
            }, 1 * 1000);
          }
        }).catch(function (_) {});
      }
    },
    handleReset: function handleReset() {
      this.queryParameter.id = null;

      if (!this.updateChannelFlag) {
        this.addInformationParameter.id = null;
      }

      this.addInformationParameter.channelGroupName = null;
      this.addInformationParameter.remark = null;
    },
    handleResetAdd: function handleResetAdd() {
      var _this10 = this;

      this.addDialogVisible = false;
      this.updateChannelFlag = false;
      this.handleReset();
      this.$nextTick(function () {
        _this10.$refs["addInformation"].clearValidate();
      });
    },
    convertOrgStatus: function convertOrgStatus(key) {
      var found = key;
      this.statusOptions.forEach(function (item) {
        if (item.key == key) {
          found = item.display_name;
          return;
        }
      });
      return found;
    },
    //Handle add check boxes for table
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    }
  }
};
exports.default = _default;